module.exports = __webpack_public_path__ + "static/media/ph.e8a85fdb.svg";